const sortCompanies = (order, items) => {
    const callBack = getSortCallback(order)
    return items.sort(callBack)
}

function getSortCallback(sort) {
    return (companyA, companyB) => {
        const result = sortDescending(companyA, companyB, sort.sortBy)
        return sort.sortDir === "desc" ? result : result * -1
    }
}

function sortDescending(companyA, companyB, key) {
    if (typeof key !== "string") {
        return 0
    }

    const companyAInfo = companyA[key]
    const companyBInfo = companyB[key]

    if (Array.isArray(companyAInfo) && Array.isArray(companyBInfo)) {
        if (companyBInfo.length === companyAInfo.length) return 0
        return companyBInfo.length > companyAInfo.length ? 1 : -1
    }

    return String(companyAInfo).localeCompare(String(companyBInfo), undefined, {
        sensitivity: "base"
    })
}

export default sortCompanies
